import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import TopBar from "@/components/layout/TopBar";
import { useWebSocket } from "@/hooks/useWebSocket";
import { Toaster } from "@/components/ui/sonner";

export const AppShell = () => {
    const [events, setEvents] = useState([]);
    const { connected } = useWebSocket((msg) => {
        if (msg?.type === "event" || msg?.type === "alert" || msg?.type === "ai_analysis") {
            setEvents((prev) => [{ ...msg, ts: new Date().toISOString() }, ...prev].slice(0, 200));
        }
    });

    // expose to children via window for cross-route access
    useEffect(() => {
        window.__GP_LIVE__ = { events, connected };
    }, [events, connected]);

    return (
        <div className="flex min-h-screen bg-background text-foreground" dir="rtl">
            <Sidebar />
            <div className="flex flex-1 flex-col min-w-0">
                <TopBar wsConnected={connected} />
                <main className="flex-1 px-4 py-4 md:px-6 md:py-6 noise-overlay">
                    <div className="mx-auto max-w-[1400px]">
                        <Outlet context={{ liveEvents: events, wsConnected: connected }} />
                    </div>
                </main>
            </div>
            <Toaster position="top-center" richColors />
        </div>
    );
};

export default AppShell;
